<template>
    <div class="members">
        <h4 class="title is-6">Members</h4>

        <space-members-form
            v-if="space_permission('SPACE_MEMBER_CREATE', space)"
            @created="reload"
            :space_id="space.id"/>

        <space-members-list
            @removed="reload"
            :members="list.data.results || []"
            :loading="list.loading"
            :space="space"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import SpaceMembersForm from './SpaceMembersForm.vue';
import SpaceMembersList from './SpaceMembersList.vue';

export default {
    props: ['space'],
    components: { SpaceMembersList, SpaceMembersForm },
    computed: mapState('space_members', ['list']),
    created() {
        this.reload();
    },
    methods: {
        reload() {
            this.$store.dispatch('space_members/list', { space: this.space.id });
        },
    },
};
</script>
